
import {defineComponent} from "vue";
import {CatalogProductsRestService} from "@/services/rest/cpc-mgmt/CatalogProductsRestService";
import BaseCardBody from "@/components/UI/Bootstrap/Card/BaseCardBody.vue";
import BaseCardHeader from "@/components/UI/Bootstrap/Card/BaseCardHeader.vue";
import BaseCard from "@/components/UI/Bootstrap/Card/BaseCard.vue";
import InputNumber from "@/components/UI/InputNumber.vue";
import {MinimalStockRestDtoModel} from "@/models/api/pharma-cpc-product-mgmt/MinimalStockRestDtoModel";
import GenericFormWrapper from "@/components/base/GenericFormWrapper.vue";
import {FormMixin} from "@/components/base/FormMixin";
import BaseDeleteButton from "@/components/UI/Bootstrap/BaseDeleteButton.vue";
import { MinimalStockRestDto } from "@/api/pharma-cpc-product-mgmt/models";

export default defineComponent({
  name: "ProductDetailMinimalStock",
  mixins: [FormMixin],
  components: {BaseDeleteButton, GenericFormWrapper, InputNumber, BaseCard, BaseCardHeader, BaseCardBody},
  props: {
    productCode: {
      type: String,
      required: true
    }
  },
  data: () => ({
    minimalStock: MinimalStockRestDtoModel.createWithDefaults() as MinimalStockRestDto,
  }),
  mounted() {
    this.reloadContent();
  },
  methods: {
    async doReload() {
      if (this.productCode) {
        this.minimalStock = await CatalogProductsRestService.getInstance().findProductCustomerMinimalStock(this.productCode);
      }
    },
    async doSubmit() {
      if (this.minimalStock.min_stock) {
        await CatalogProductsRestService.getInstance().syncProductCustomerMinimalStock(
          this.productCode,
          new MinimalStockRestDtoModel(this.minimalStock.min_stock)
        );
      }
    },
    async doDelete() {
      await CatalogProductsRestService.getInstance().deleteProductCustomerMinimalStock(this.productCode);
    },
  },
});
